import spinach from "../assets/images/baskets/spinach.png";
import carrot from "../assets/images/baskets/carrot.png";
import broccoli from "../assets/images/baskets/broccoli.png";
import sweetPotato from "../assets/images/baskets/sweet-potato.png";
import cauliflower from "../assets/images/baskets/cauliflower.png";
import tomatoes from "../assets/images/baskets/tomatoes.png";
import apple from "../assets/images/baskets/apple.png";
import pear from "../assets/images/baskets/pear.png";
import kiwi from "../assets/images/baskets/kiwi.png";
import banana from "../assets/images/baskets/banana.png";
import orange from "../assets/images/baskets/orange.png";
import mango from "../assets/images/baskets/mango.png";

export const wheelBasketImages = {
  spinach,
  carrot,
  broccoli,
  sweetPotato,
  cauliflower,
  tomatoes,
  apple,
  pear,
  kiwi,
  banana,
  orange,
  mango,
};

export const wheelData = [
  {
    id: 1,
    name: "spinach",
    header: "Spinach",
    data: [
      {
        type: "list",
        dataHeader: "Health Benefits of Spinach",
        content: [
          {
            head: "Rich in Nutrients",
            body: "Spinach is a nutrient-dense leafy green, providing vitamins A, C, and K, folate, iron, and fiber. These nutrients support various bodily functions, including immune health, blood clotting, and digestive health.",
          },
          {
            head: "Supports Heart Health",
            body: "The potassium content in spinach helps regulate blood pressure, reducing the risk of heart disease and stroke. Additionally, antioxidants like lutein and nitrates in spinach may prevent insulin resistance and reduce inflammation, further supporting cardiovascular health.",
          },
          {
            head: "Enhances Vision",
            body: "Spinach contains lutein and zeaxanthin, antioxidants that protect the eyes from oxidative stress and may lower the risk of age-related macular degeneration and cataracts.",
          },
          {
            head: "Promotes Bone Health",
            body: "High in vitamin K, spinach plays a crucial role in calcium absorption and bone mineralization, contributing to strong and healthy bones.",
          },
          {
            head: "Aids in Digestion",
            body: "The dietary fiber in spinach promotes healthy digestion by adding bulk to stool and facilitating regular bowel movements, reducing the risk of constipation.",
          },
          {
            head: "Anti-Cancer Properties",
            body: "Spinach contains antioxidants and phytochemicals that may reduce oxidative stress and lower the risk of certain cancers, including colon, breast, and ovarian cancers.",
          },
          {
            head: "Supports Brain Health",
            body: "Nutrients like vitamin K, folate, and beta-carotene in spinach may promote brain health and slow cognitive decline, supporting memory and overall cognitive function.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Make like Popeye: The powerful benefits of spinach",
            body: "https://web.uri.edu/chs/2018/03/22/make-like-popeye-the-powerful-benefits-of-spinach/",
          },
          {
            head: "Greening your health with Spinach",
            body: "https://www.canr.msu.edu/news/greening_your_health_with_spinach",
          },
          {
            head: "7 reasons you should eat more Spinach",
            body: "https://health.clevelandclinic.org/benefits-of-spinach",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "carrot",
    header: "Carrot",
    data: [
      {
        type: "list",
        dataHeader: "Health Benefits of Carrots",
        content: [
          {
            head: "Enhances Vision Health",
            body: "Carrots are rich in beta-carotene, a compound that the body converts into vitamin A. This vitamin is essential for maintaining healthy vision, particularly in low-light conditions. A deficiency in vitamin A can lead to night blindness and other vision issues.",
          },
          {
            head: "Supports Immune Function",
            body: "The vitamin A derived from beta-carotene in carrots plays a crucial role in supporting the immune system. It helps maintain the integrity of mucous membranes in the eyes, respiratory tract, and gut, acting as a barrier against infections.",
          },
          {
            head: "Promotes Skin Health",
            body: "Carrots contain antioxidants, including beta-carotene and vitamin C, which contribute to skin health. Vitamin C aids in collagen production, essential for skin elasticity and wound healing, while beta-carotene may help protect the skin from sun damage.",
          },
          {
            head: "Aids Digestive Health",
            body: "High in dietary fiber, carrots support digestive health by promoting regular bowel movements and preventing constipation. Fiber also contributes to a feeling of fullness, which can aid in weight management.",
          },
          {
            head: "May Reduce Cancer Risk",
            body: "The antioxidants in carrots, such as beta-carotene, lutein, and zeaxanthin, have been associated with a reduced risk of certain cancers. These compounds help neutralize harmful free radicals in the body, potentially lowering the risk of cancer development.",
          },
          {
            head: "Supports Cardiovascular Health",
            body: "Carrots provide potassium, a mineral that helps maintain healthy blood pressure levels. Additionally, the fiber in carrots can help reduce cholesterol levels, contributing to overall heart health.",
          },
          {
            head: "Assists in Blood Sugar Regulation",
            body: "Despite their natural sweetness, carrots have a low glycemic index, meaning they have a minimal impact on blood sugar levels. The fiber content in carrots also helps regulate blood sugar by slowing the absorption of sugar into the bloodstream.",
          },
          {
            head: "Contributes to Bone Health",
            body: "Carrots contain vitamin K and small amounts of calcium and phosphorus, all of which contribute to bone health. Vitamin K is essential for bone mineralization and may help reduce the risk of osteoporosis.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Happy Healthy Carrots Fact Sheet",
            body: "https://happyhealthy.extension.msstate.edu/fact-sheets/happyhealthy-carrots-fact-sheet",
          },
          {
            head: "Carrots in Massachusetts",
            body: "https://www.umass.edu/agriculture-food-environment/nutrition/publications-resources/harvest-of-month/carrots",
          },
          {
            head: "Vitamin A",
            body: "https://www.umass.edu/agriculture-food-environment/nutrition/publications-resources/harvest-of-month/carrots",
          },
          {
            head: "Carrots & Eye Health: Myth or Fact?",
            body: "https://healthcare.utah.edu/healthfeed/2025/04/carrots-eye-health-myth-or-fact",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "broccoli",
    header: "Broccoli",
    data: [
      {
        type: "list",
        dataHeader: "Health Benefits of Broccoli",
        content: [
          {
            head: "Cancer Prevention",
            body: "Broccoli contains sulforaphane, a potent phytochemical that has been shown to have anti-cancer properties. Research from UCLA Health indicates that sulforaphane can reduce the risk of various cancers, including prostate, breast, colon, and oral cancers. This compound works by neutralizing toxins, reducing inflammation, and protecting DNA from mutations that can lead to cancer.",
          },
          {
            head: "Immune System Support",
            body: "A study conducted by UCLA researchers found that sulforaphane in broccoli can enhance the body's immune response, particularly in older adults. Sulforaphane activates antioxidant genes and enzymes in immune cells, combating oxidative stress and potentially reversing age-related declines in immune function.",
          },
          {
            head: "Cardiovascular Health",
            body: "Broccoli is rich in dietary fiber, potassium, and antioxidants, all of which contribute to heart health. The fiber helps lower cholesterol levels, while potassium aids in maintaining healthy blood pressure. Antioxidants in broccoli reduce oxidative stress, which is linked to heart disease.",
          },
          {
            head: "Bone Health",
            body: "This vegetable is a good source of vitamin K and calcium, both essential for bone health. Vitamin K plays a crucial role in bone mineralization, and adequate intake has been associated with a reduced risk of fractures.",
          },
          {
            head: "Eye Health",
            body: "Broccoli contains lutein and zeaxanthin, antioxidants that are beneficial for eye health. These compounds help protect the eyes from harmful light waves and oxidative stress, potentially reducing the risk of age-related macular degeneration.",
          },
          {
            head: "Digestive Health",
            body: "The high fiber content in broccoli supports digestive health by promoting regular bowel movements and maintaining a healthy gut microbiome. Fiber also aids in preventing constipation and may reduce the risk of colorectal cancer.",
          },
          {
            head: "Brain Health",
            body: "Broccoli's antioxidants and bioactive compounds may contribute to healthy brain function. Some studies suggest that these compounds can reduce inflammation and oxidative stress in the brain, potentially lowering the risk of neurodegenerative diseases.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Broccoli - Key Features",
            body: "https://www.chhs.colostate.edu/fsi/food-articles/produce/broccoli/",
          },
          {
            head: "Broccoli: Health Benefits, Risks and Nutrition Facts",
            body: "https://www.livescience.com/45408-broccoli-nutrition.html",
          },
          {
            head: "Broccoli: A Multi-Faceted Vegetable for Health",
            body: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10376324/",
          },
          {
            head: "Broccoli Nutrition & Calories - Complete Data of All Nutrients",
            body: "https://foodstruct.com/food/broccoli",
          },
          {
            head: "Broccoli and other cruciferous veggies can significantly lower cancer risks",
            body: "https://www.uclahealth.org/news/article/broccoli-and-other-cruciferous-veggies-can-significantly-lower-cancer-risks",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: "sweetPotato",
    header: "Sweet Potato",
    data: [
      {
        type: "list",
        dataHeader: "Health Benefits of Sweet Potatoes",
        content: [
          {
            head: "Supports Eye Health",
            body: "Rich in beta-carotene, which the body converts to vitamin A, sweet potatoes help maintain healthy vision and may reduce the risk of age-related macular degeneration.",
          },
          {
            head: "Enhances Immune Function",
            body: "Vitamin A and vitamin C in sweet potatoes bolster the immune system, aiding in the defense against infections.",
          },
          {
            head: "Promotes Digestive Health",
            body: "High fiber content supports a healthy digestive tract, preventing constipation and promoting regularity.",
          },
          {
            head: "Regulates Blood Sugar",
            body: "Despite their sweetness, sweet potatoes have a low glycemic index, helping to manage blood sugar levels.",
          },
          {
            head: "Supports Heart Health",
            body: "Potassium and magnesium in sweet potatoes help regulate blood pressure and maintain heart health.",
          },
          {
            head: "Anti-Inflammatory Properties",
            body: "Compounds like anthocyanins and choline reduce inflammation, which is beneficial for overall health.",
          },
          {
            head: "Enhances Brain Function",
            body: "Antioxidants in sweet potatoes may improve cognitive function and reduce the risk of neurodegenerative diseases.",
          },
          {
            head: "Supports Skin Health",
            body: "Vitamin A and C contribute to healthy skin by promoting collagen production and protecting against sun damage.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Body Systems and Organs Affected",
        content: [
          {
            head: "Eyes",
            body: "Vitamin A supports vision and eye health.",
          },
          {
            head: "Immune System",
            body: "Vitamins A and C enhance immune defenses.",
          },
          {
            head: "Digestive System",
            body: "Dietary fiber promotes gut health and regularity.",
          },
          {
            head: "Cardiovascular System",
            body: "Potassium and magnesium regulate blood pressure and heart function.",
          },
          {
            head: "Nervous System",
            body: "Antioxidants support brain health and cognitive function.",
          },
          {
            head: "Skin",
            body: "Vitamins A and C maintain skin integrity and appearance.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Nutritional Benefits of Sweet Potatoes",
            body: "https://franklin.ces.ncsu.edu/2025/05/nutritional-benefits-of-sweetpotatoes/",
          },
          {
            head: "Why purple sweet potatoes belong on your holiday table",
            body: "https://www.universityofcalifornia.edu/news/why-purple-sweet-potatoes-belong-your-holiday-table",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "cauliflower",
    header: "Cauliflower",
    data: [
      {
        type: "list",
        dataHeader: "Health Benefits of Cauliflower",
        content: [
          {
            head: "Supports Immune Function",
            body: "Cauliflower is an excellent source of vitamin C, which plays a vital role in immune system support by helping to heal cuts and wounds and acting as an antioxidant.",
          },
          {
            head: "Promotes Digestive Health",
            body: "The dietary fiber in cauliflower aids in digestion, helps prevent constipation, and contributes to a feeling of fullness, which can assist in weight management.",
          },
          {
            head: "Supports Heart Health",
            body: "Cauliflower contains potassium, an electrolyte that is essential for muscle contraction and maintaining healthy blood pressure levels.",
          },
          {
            head: "Provides Antioxidant Protection",
            body: "The vitamin C content in cauliflower acts as an antioxidant, helping to protect the body against free radical damage and reducing the risk of chronic diseases.",
          },
          {
            head: "Supports Bone Health",
            body: "Cauliflower provides vitamin K, which is important for blood clotting and bone metabolism.",
          },
          {
            head: "May Reduce Cancer Risk",
            body: "Cauliflower contains phytochemicals that may protect against cancer, similar to other cruciferous vegetables.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Body Systems and Organs Affected",
        content: [
          {
            head: "Immune System",
            body: "Vitamin C enhances immune defenses.",
          },
          {
            head: "Digestive System",
            body: "Dietary fiber promotes gut health and regularity.",
          },
          {
            head: "Cardiovascular System",
            body: "Potassium helps regulate blood pressure and heart function.",
          },
          {
            head: "Skeletal System",
            body: "Vitamin K contributes to bone health.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Vegetable of the Month: Cauliflower",
            body: "https://www.health.harvard.edu/heart-health/vegetable-of-the-month-cauliflower",
          },
          {
            head: "January: Cauliflower",
            body: "https://sites.udel.edu/chs-udfoodlab/2020/01/15/january-cauliflower/",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: "tomatoes",
    header: "Tomatoes",
    data: [
      {
        type: "list",
        dataHeader: "Health Benefits of Tomatoes",
        content: [
          {
            head: "Rich in Antioxidants",
            body: "Tomatoes are a significant source of lycopene, an antioxidant that may help reduce the risk of certain cancers and heart disease.",
          },
          {
            head: "Supports Heart Health",
            body: "The potassium and vitamin B in tomatoes help lower blood pressure and cholesterol levels, contributing to heart disease prevention.",
          },
          {
            head: "Enhances Vision",
            body: "Vitamin A in tomatoes can improve vision, help prevent night blindness, and may reduce the risk of macular degeneration.",
          },
          {
            head: "Promotes Skin Health",
            body: "Beta-carotene and lycopene in tomatoes help protect the skin against damage and make it less sensitive to UV damage.",
          },
          {
            head: "Aids in Blood Sugar Regulation",
            body: "Tomatoes contain chromium, which helps maintain blood sugar levels and may reduce the risk of diabetes.",
          },
          {
            head: "Supports Bone Health",
            body: "Vitamin K, calcium, and lycopene in tomatoes are beneficial for strengthening and repairing bones.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Body Systems and Organs Affected",
        content: [
          {
            head: "Cardiovascular System",
            body: "Potassium and vitamin B help regulate blood pressure and cholesterol.",
          },
          {
            head: "Visual System",
            body: "Vitamin A supports eye health and vision.",
          },
          {
            head: "Integumentary System (Skin)",
            body: "Antioxidants like beta-carotene and lycopene protect the skin from UV damage.",
          },
          {
            head: "Endocrine System",
            body: "Chromium aids in blood sugar regulation.",
          },
          {
            head: "Skeletal System",
            body: "Vitamin K and calcium contribute to bone strength and repair.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Tomatoes - Key Facts",
            body: "https://food.unl.edu/article/tomatoes/",
          },
          {
            head: "Tomatoes provide many health benefits",
            body: "https://www.canr.msu.edu/news/tomatoes_provide_many_health_benefits",
          },
          {
            head: "Cooking tomatoes boosts nutritional power",
            body: "https://news.cornell.edu/stories/2002/04/cooking-tomatoes-boosts-disease-fighting-power",
          },
          {
            head: "Eating more tomatoes may help lower high blood pressure",
            body: "https://www.health.harvard.edu/staying-healthy/eating-more-tomatoes-may-help-lower-high-blood-pressure",
          },
          {
            head: "Nutrition Facts",
            body: "https://www.urmc.rochester.edu/encyclopedia/content?contentid=11529-11&contenttypeid=76",
          },
        ],
      },
    ],
  },
  {
    id: 7,
    name: "apple",
    header: "Apple",
    data: [
      {
        type: "para",
        dataHeader: "Why Are Apples Important?",
        content: [
          "Apples are a widely consumed fruit known for their health-promoting properties. They are rich in fiber and polyphenols, which contribute to various health benefits, including heart health and weight management. Regular consumption of apples has been associated with a reduced risk of chronic diseases.",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients and Minerals in Apples",
        content: [
          {
            head: "Calories",
            body: "About 95 kcal",
          },
          {
            head: "Dietary Fiber",
            body: "4 grams",
          },
          {
            head: "Vitamin C",
            body: "14% of the Daily Value (DV)",
          },
          {
            head: "Potassium",
            body: "6% of the DV",
          },
          {
            head: "Carbohydrates",
            body: "25 grams",
          },
          {
            head: "Natural Sugars",
            body: "19 grams",
          },
          {
            head: "Other Nutrients",
            body: "Small amounts of vitamin K, vitamin B6, manganese, and copper",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Benefits for Specific Body Systems",
        content: [
          {
            head: "Digestive System",
            body: "The dietary fiber in apples supports healthy digestion and can help prevent constipation.",
          },
          {
            head: "Cardiovascular System",
            body: "Regular apple consumption has been linked to lower blood pressure and cholesterol levels, contributing to heart health.",
          },
          {
            head: "Immune System",
            body: "Vitamin C and other antioxidants in apples help strengthen the immune system and protect against oxidative stress.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Other Health Benefits",
        content: [
          {
            head: "Weight Management",
            body: "The fiber and water content in apples can promote feelings of fullness, aiding in weight control.",
          },
          {
            head: "Cancer Prevention",
            body: "Phytochemicals in apples, such as quercetin and catechin, have antioxidant properties that may help reduce the risk of certain cancers.",
          },
          {
            head: "Bone Health",
            body: "Some studies suggest that the antioxidants and anti-inflammatory compounds in apples may promote bone health.",
          },
          {
            head: "Summary",
            body: "Apples are a nutritious and versatile fruit that can contribute to various aspects of health, making them an excellent choice for children's diets.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Nutrition News - Apples are simple and healthful, yet full of variety",
            body: "https://extension.colostate.edu/topic-areas/nutrition-food-safety-health/nutrition-news/nutrition-news-apples-are-simple-and-healthful-yet-full-of-variety/",
          },
          {
            head: "Apples and Health",
            body: "https://nutritionsource.hsph.harvard.edu/food-features/apples/",
          },
          {
            head: "Fruit of the month: Apples",
            body: "https://www.health.harvard.edu/heart-health/fruit-of-the-month-apples",
          },
          {
            head: "Real Life, Good Food - Apples",
            body: "https://reallifegoodfood.umn.edu/fruits/apples",
          },
          {
            head: "Apple - Facts",
            body: "https://www.fcs.uga.edu/docs/FDNS-E-167-5.pdf",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    name: "pear",
    header: "Pear",
    data: [
      {
        type: "para",
        dataHeader: "Why Are Pears Important?",
        content: [
          "Pears are a versatile and nutritious fruit that can be enjoyed in various forms—fresh, baked, or added to salads. They are known for their sweet flavor and are a good source of dietary fiber and essential nutrients. Regular consumption of pears has been associated with various health benefits, making them an excellent choice for children's diets.",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients and Minerals in Pears",
        content: [
          {
            head: "Calories",
            body: "100",
          },
          {
            head: "Dietary Fiber",
            body: "6 grams (16% of Daily Value)",
          },
          {
            head: "Vitamin C",
            body: "6 mg (7% of Daily Value)",
          },
          {
            head: "Potassium",
            body: "Approximately 200 mg",
          },
          {
            head: "Vitamin K",
            body: "Approximately 10% of Daily Value",
          },
          {
            head: "Natural Sugars",
            body: "16 grams",
          },
          {
            head: "Protein",
            body: "1 gram",
          },
          {
            head: "Fat",
            body: "0 grams",
          },
          {
            head: "Other Nutrients",
            body: "Small amounts of vitamin B6, magnesium, and copper",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Benefits for Specific Body Systems",
        content: [
          {
            head: "Digestive System",
            body: "The high fiber content in pears aids in digestion and helps maintain regular bowel movements. The pectin in pears acts as a prebiotic, promoting gut health.",
          },
          {
            head: "Cardiovascular System",
            body: "Pears are rich in flavonoids, such as catechins, which have been shown to improve blood vessel health and may help lower blood pressure.",
          },
          {
            head: "Immune System",
            body: "The vitamin C content in pears supports the immune system by protecting against oxidative stress and aiding in the production of white blood cells.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Other Health Benefits",
        content: [
          {
            head: "Anti-Inflammatory Properties",
            body: "Pears contain antioxidants and anti-inflammatory compounds that may help reduce the risk of chronic diseases such as heart disease and type 2 diabetes.",
          },
          {
            head: "Weight Management",
            body: "Low in calories and high in fiber, pears can promote a feeling of fullness, which may aid in weight management.",
          },
          {
            head: "Skin Health",
            body: "The antioxidants in pears, including vitamin C, contribute to healthy skin by combating free radicals that can cause skin aging.",
          },
          {
            head: "Summary",
            body: "Pears are a nutritious and delicious fruit that offer a range of health benefits, making them an excellent addition to children's diets.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Pears - Key Details",
            body: "https://www.umass.edu/agriculture-food-environment/nutrition/publications-resources/harvest-of-month/pears",
          },
          {
            head: "The Nutritional Story of Pears",
            body: "https://depts.washington.edu/nutr/wordpress/wp-content/uploads/2015/03/Pears-2013.pdf",
          },
          {
            head: "Fruit of the month: Pears",
            body: "https://www.health.harvard.edu/heart-health/fruit-of-the-month-pears",
          },
          {
            head: "The Perfect Pear!",
            body: "https://crw.ecu.edu/2019/05/07/healthy-fruits-pears/",
          },
        ],
      },
    ],
  },
  {
    id: 9,
    name: "kiwi",
    header: "Kiwi",
    data: [
      {
        type: "para",
        dataHeader: "Why Is It Important?",
        content: [
          "Kiwi is a nutrient-dense fruit, offering a rich supply of vitamin C and other essential nutrients. It's known for its antioxidant properties and potential digestive benefits.",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients and Minerals in Kiwi",
        content: [
          {
            head: "Calories",
            body: "64",
          },
          {
            head: "Carbohydrates",
            body: "14g",
          },
          {
            head: "Fiber",
            body: "3g (11% DV)",
          },
          {
            head: "Protein",
            body: "1g",
          },
          {
            head: "Fat",
            body: "0.44g",
          },
          {
            head: "Vitamin C",
            body: "83% DV",
          },
          {
            head: "Vitamin E",
            body: "9% DV",
          },
          {
            head: "Vitamin K",
            body: "34% DV",
          },
          {
            head: "Folate",
            body: "7% DV",
          },
          {
            head: "Potassium",
            body: "4% DV",
          },
          {
            head: "Magnesium",
            body: "4% DV",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Benefits for Specific Body Systems",
        content: [
          {
            head: "Immune System",
            body: "High vitamin C content enhances immune response.",
          },
          {
            head: "Digestive System",
            body: "Fiber aids in digestion and may alleviate constipation.",
          },
          {
            head: "Cardiovascular System",
            body: "Potassium contributes to heart health.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Other Health Benefits",
        content: [
          {
            head: "Antioxidant Support",
            body: "Antioxidant properties may reduce oxidative stress.",
          },
          {
            head: "Weight Management",
            body: "Low in calories, making it suitable for weight management.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "4 Health Benefits of Kiwi",
            body: "https://www.healthline.com/nutrition/kiwi-benefits",
          },
          {
            head: "Kiwifruit, 700 Year Old Fruit with Emerald Green Color",
            body: "https://www.uaex.uada.edu/counties/miller/news/fcs/fruits-veggies/Kiwifruit-700_Year_Old_Fruit_with_Emerald_Green_Color.aspx",
          },
        ],
      },
    ],
  },
  {
    id: 10,
    name: "banana",
    header: "Banana",
    data: [
      {
        type: "para",
        dataHeader: "Why Are They Important?",
        content: [
          "Bananas are a widely consumed fruit known for their convenience, affordability, and nutritional value. They are rich in essential nutrients such as potassium, vitamin B6, vitamin C, and dietary fiber. These nutrients contribute to various health benefits, including heart health, digestive support, and energy provision. Incorporating bananas into your diet can offer various health benefits. They can be enjoyed on their own, added to cereals, blended into smoothies, or used in baking.",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients and Minerals in Bananas",
        content: [
          {
            head: "Calories",
            body: "89 kcal",
          },
          {
            head: "Protein",
            body: "1.1 g",
          },
          {
            head: "Carbohydrates",
            body: "22.8 g",
          },
          {
            head: "Fiber",
            body: "2.6 g",
          },
          {
            head: "Sugars",
            body: "12.2 g",
          },
          {
            head: "Fat",
            body: "0.3 g",
          },
          {
            head: "Potassium",
            body: "358 mg (10% DV)",
          },
          {
            head: "Vitamin B6",
            body: "0.4 mg (20% DV)",
          },
          {
            head: "Vitamin C",
            body: "8.7 mg (10% DV)",
          },
          {
            head: "Magnesium",
            body: "27 mg (7% DV)",
          },
          {
            head: "Manganese",
            body: "0.3 mg (13% DV)",
          },
          {
            head: "Folate",
            body: "20 mcg (5% DV)",
          },
          {
            head: "Vitamin A",
            body: "64 IU (1% DV)",
          },
          {
            head: "Iron",
            body: "0.3 mg (2% DV)",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Benefits for Specific Body Systems",
        content: [
          {
            head: "Digestive System",
            body: "Bananas are rich in dietary fiber and contain inulin, a substance that stimulates the growth of beneficial gut bacteria, promoting healthy digestion.",
          },
          {
            head: "Cardiovascular System",
            body: "The high potassium content in bananas helps regulate blood pressure and supports heart health.",
          },
          {
            head: "Nervous System",
            body: "Vitamin B6 in bananas is essential for neurotransmitter synthesis, supporting brain health.",
          },
          {
            head: "Immune System",
            body: "Vitamin C contributes to immune defense by supporting various cellular functions.",
          },
          {
            head: "Muscular System",
            body: "Magnesium and potassium are vital for muscle function and preventing cramps.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Other Health Benefits",
        content: [
          {
            head: "Energy Boost",
            body: "Natural sugars and carbohydrates in bananas provide a quick energy source, making them a popular choice for pre- or post-workout snacks.",
          },
          {
            head: "Digestive Health",
            body: "Bananas are a low-fructose fruit that are fiber-rich and contain inulin, a substance that stimulates the growth of good bacteria in the gut.",
          },
          {
            head: "Heartburn Relief",
            body: "Bananas are considered an alkaline food, which can help offset strong stomach acid and alleviate symptoms of acid reflux.",
          },
          {
            head: "Child-Friendly Nutrition",
            body: "Bananas are recommended for children as part of an anti-inflammatory diet, which may decrease inflammation and lower the risk of chronic diseases.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Anti Inflammatory Diet",
            body: "https://www.hopkinsmedicine.org/health/wellness-and-prevention/gerd-diet-foods-that-help-with-acid-reflux-heartburn",
          },
          {
            head: "Food as Medicine: Anti-Inflammatory Diet",
            body: "https://www.chop.edu/health-resources/food-medicine-anti-inflammatory-diet",
          },
        ],
      },
    ],
  },
  {
    id: 11,
    name: "orange",
    header: "Orange",
    data: [
      {
        type: "para",
        dataHeader: "Why Are They Important?",
        content: [
          "Oranges are a rich source of vitamin C, which is essential for immune function, skin health, and antioxidant protection. They also provide dietary fiber, potassium, and various phytonutrients that contribute to overall health. Incorporating oranges into your diet can offer various health benefits. They can be enjoyed fresh, juiced, or added to salads and desserts.",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients and Minerals in Orange per 100g",
        content: [
          {
            head: "Calories",
            body: "47 kcal",
          },
          {
            head: "Protein",
            body: "0.9 g",
          },
          {
            head: "Carbohydrates",
            body: "11.8 g",
          },
          {
            head: "Fiber",
            body: "2.4 g",
          },
          {
            head: "Sugars",
            body: "9.4 g",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Benefits for Specific Body Systems",
        content: [
          {
            head: "Immune System",
            body: "High vitamin C content supports immune defense mechanisms.",
          },
          {
            head: "Cardiovascular System",
            body: "Potassium helps regulate blood pressure and supports heart health.",
          },
          {
            head: "Digestive System",
            body: "Dietary fiber aids in digestion and promotes regular bowel movements.",
          },
          {
            head: "Skin Health",
            body: "Vitamin C is vital for collagen synthesis, contributing to healthy skin.",
          },
          {
            head: "Eye Health",
            body: "Vitamin A in the form of beta-carotene supports vision and eye health.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Other Health Benefits",
        content: [
          {
            head: "Antioxidant Properties",
            body: "Oranges contain flavonoids and carotenoids that help combat oxidative stress.",
          },
          {
            head: "Hydration",
            body: "High water content aids in maintaining hydration levels.",
          },
          {
            head: "Weight Management",
            body: "Low in calories and high in fiber, oranges can promote satiety.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Eating in Color - Orange and Yellow Produce",
            body: "https://blogs.cornell.edu/communityeducation/2021/07/27/eating-in-color-orange-and-yellow-produce/",
          },
          {
            head: "Why Good Nutrition is Important",
            body: "https://www.cspinet.org/eating-healthy/why-good-nutrition-important",
          },
          {
            head: "Oranges - Key Features",
            body: "https://reallifegoodfood.umn.edu/fruits/oranges",
          },
          {
            head: "Fruit of the month: Citrus fruits",
            body: "https://www.health.harvard.edu/heart-health/fruit-of-the-month-citrus-fruits",
          },
          {
            head: "6 Health Benefits of Citrus",
            body: "https://source.colostate.edu/6-health-benefits-citrus/",
          },
        ],
      },
    ],
  },
  {
    id: 12,
    name: "mango",
    header: "Mango",
    data: [
      {
        type: "para",
        dataHeader: "Why Are They Important?",
        content: [
          "Mangoes are not only delicious but also packed with essential nutrients and bioactive compounds that contribute to overall health. They are rich in vitamins A and C, dietary fiber, and various antioxidants, making them a valuable addition to a balanced diet. Incorporating mangoes into your diet can offer various health benefits. They can be enjoyed fresh, blended into smoothies, added to salads, or used in desserts.",
        ],
      },
      {
        type: "list",
        dataHeader: "Nutrients and Minerals in Mangoes per 100g",
        content: [
          { head: "Calories", body: "60 kcal" },
          { head: "Protein", body: "0.82 g" },
          { head: "Total Fat", body: "0.38 g" },
          { head: "Carbohydrates", body: "14.98 g" },
          { head: "Dietary Fiber", body: "1.6 g" },
          { head: "Sugars", body: "13.66 g" },
          { head: "Vitamin C", body: "36.4 mg" },
          { head: "Vitamin A", body: "54 µg" },
          { head: "Folate (Vitamin B9)", body: "43 µg" },
          { head: "Potassium", body: "168 mg" },
          { head: "Magnesium", body: "10 mg" },
          { head: "Calcium", body: "11 mg" },
        ],
      },
      {
        type: "list",
        dataHeader: "Benefits for Specific Body Systems",
        content: [
          {
            head: "Immune System",
            body: "High vitamin C content supports immune defense mechanisms.",
          },
          {
            head: "Digestive System",
            body: "Dietary fiber aids in digestion and promotes regular bowel movements.",
          },
          {
            head: "Skin Health",
            body: "Vitamin A and antioxidants contribute to healthy skin and may reduce signs of aging.",
          },
          {
            head: "Cardiovascular System",
            body: "Potassium helps regulate blood pressure and supports heart health.",
          },
          {
            head: "Metabolic Health",
            body: "Bioactive compounds in mangoes may aid in blood glucose regulation and lipid metabolism.",
          },
        ],
      },
      {
        type: "list",
        dataHeader: "Other Health Benefits",
        content: [
          {
            head: "Antioxidant Properties",
            body: "Mangoes contain mangiferin and other polyphenols that combat oxidative stress.",
          },
          {
            head: "Anti-inflammatory Effects",
            body: "Regular consumption may reduce inflammation markers in the body.",
          },
          {
            head: "Weight Management",
            body: "Low in calories and high in fiber, mangoes can promote satiety and support weight management.",
          },
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "Texas A&M AgriLife study: Mango provides additional relief from chronic constipation",
            body: "https://agrilifetoday.tamu.edu/2018/08/22/texas-am-agrilife-study-mango-provides-additional-relief-from-chronic-constipation/",
          },
          {
            head: "Nutrition Facts - Mango",
            body: "https://hf-foodpro.austin.utexas.edu/foodpro/label.aspx?RecNumAndPort=153933%2A4&dtdate=1%2F11%2F2025&locationName=J2+Dining&locationNum=12",
          },
          {
            head: "Nutritional sciences researcher finds mangos beneficial",
            body: "https://news.okstate.edu/articles/communications/2011/nutritional-sciences-researcher-finds-mangos-beneficial.html",
          },
          {
            head: "Benefits of mangos for the body",
            body: "https://www.canr.msu.edu/news/benefits_of_mangos_for_the_body",
          },
        ],
      },
    ],
  },
];

export default wheelData;
